import { GetErgonomicWorkAnalysisImagesResponseDTO } from '@/core/dto/ergonomic-work-analisys';
import type { CustomUploadFile } from '@/views/ErgonomicWorkAnalysis/Report/Steps/Attachment/types';

export class GetErgonomicWorkAnalysisImagesMapper {
	constructor(private readonly data: GetErgonomicWorkAnalysisImagesResponseDTO[]) {}

	toDomain(): CustomUploadFile[] {
		const images: CustomUploadFile[] = this.data?.map((image) => {
			return {
				uid: image.id,
				name: image.location,
				description: image.description || '',
				status: 'done',
				url: image.image_url
			};
		});

		return images;
	}
}
